import React from 'react';
import { Shield } from 'lucide-react';
import ServiceTemplate from './ServiceTemplate';

const CybercrimePage = () => {
  const serviceData = {
    icon: Shield,
    nameAr: 'دائرة الجرائم المعلوماتية',
    nameEn: 'Cybercrime Department',
    taglineAr: 'حماية قانونية متخصصة في الجرائم الإلكترونية',
    taglineEn: 'Specialized legal protection in electronic crimes',
    
    descriptionAr: [
      'دائرة الجرائم المعلوماتية في وازن متخصصة في التعامل مع جميع أنواع الجرائم الإلكترونية والمعلوماتية. نقدم خدمات قانونية شاملة للضحايا والمتهمين على حد سواء، مع خبرة عميقة في التعامل مع الأدلة الرقمية.',
      'نعمل وفق نظام مكافحة الجرائم المعلوماتية السعودي ونتعاون مع الجهات المختصة لضمان حماية حقوق عملائنا وتقديم أفضل دفاع قانوني ممكن.'
    ],
    descriptionEn: [
      'Wazin\'s Cybercrime Department specializes in handling all types of electronic and information crimes. We provide comprehensive legal services for both victims and accused, with deep expertise in handling digital evidence.',
      'We work in accordance with Saudi Anti-Cybercrime Law and cooperate with competent authorities to ensure protection of our clients\' rights and provide the best possible legal defense.'
    ],

    services: [
      {
        nameAr: 'إدارة قضايا الابتزاز الإلكتروني وحماية الضحايا',
        nameEn: 'Managing electronic blackmail cases and protecting victims',
        descAr: 'التعامل الفوري مع حالات الابتزاز الإلكتروني واتخاذ الإجراءات القانونية لحماية الضحايا',
        descEn: 'Immediate handling of electronic blackmail cases and taking legal actions to protect victims'
      },
      {
        nameAr: 'معالجة قضايا اختراق الحسابات الإلكترونية والتطبيقات',
        nameEn: 'Handling electronic accounts and applications hacking cases',
        descAr: 'التعامل مع حالات اختراق الحسابات الشخصية والتطبيقات واسترداد السيطرة عليها',
        descEn: 'Handling cases of personal accounts and applications hacking and recovering control'
      },
      {
        nameAr: 'قضايا التشهير الإلكتروني عبر منصات التواصل',
        nameEn: 'Electronic defamation cases via social media platforms',
        descAr: 'رفع قضايا التشهير والقدح والذم عبر منصات التواصل الاجتماعي',
        descEn: 'Filing defamation and libel cases via social media platforms'
      },
      {
        nameAr: 'قضايا انتحال الهوية والحسابات الوهمية',
        nameEn: 'Identity theft and fake accounts cases',
        descAr: 'معالجة قضايا انتحال الشخصية وإنشاء حسابات وهمية باسم الغير',
        descEn: 'Handling identity theft cases and creating fake accounts in others names'
      },
      {
        nameAr: 'قضايا الاحتيال الإلكتروني والمعاملات المالية الإلكترونية',
        nameEn: 'Electronic fraud and electronic financial transactions cases',
        descAr: 'معالجة قضايا الاحتيال المالي الإلكتروني والمعاملات المشبوهة',
        descEn: 'Handling electronic financial fraud cases and suspicious transactions'
      },
      {
        nameAr: 'الترافع في القضايا المرتبطة بالجرائم المعلوماتية أمام الجهات المختصة',
        nameEn: 'Pleading in cybercrime cases before competent authorities',
        descAr: 'تمثيل العملاء والترافع في القضايا المعلوماتية أمام المحاكم المختصة',
        descEn: 'Representing clients and pleading in cybercrime cases before competent courts'
      },
      {
        nameAr: 'التنسيق مع الجهات المختصة في الأمن السيبراني والجهات الأمنية',
        nameEn: 'Coordinating with cybersecurity and security authorities',
        descAr: 'التنسيق والمتابعة مع هيئة الأمن السيبراني والجهات الأمنية المختصة',
        descEn: 'Coordinating and following up with National Cybersecurity Authority and competent security entities'
      },
      {
        nameAr: 'تقديم استشارات وقائية تتعلق بالأمن السيبراني القانوني وحماية السمعة الرقمية',
        nameEn: 'Providing preventive consultations on legal cybersecurity and digital reputation protection',
        descAr: 'تقديم استشارات وقائية للأفراد والشركات لحماية بياناتهم وسمعتهم الرقمية',
        descEn: 'Providing preventive consultations to individuals and companies to protect their data and digital reputation'
      }
    ],

    specializations: [
      { ar: 'الابتزاز الإلكتروني', en: 'Electronic Blackmail' },
      { ar: 'التشهير عبر تويتر وإنستقرام', en: 'Defamation via Twitter and Instagram' },
      { ar: 'الاحتيال في التجارة الإلكترونية', en: 'E-commerce Fraud' },
      { ar: 'سرقة الهوية الرقمية', en: 'Digital Identity Theft' },
      { ar: 'اختراق المواقع والأنظمة', en: 'Website and System Hacking' },
      { ar: 'انتهاك حقوق الملكية الفكرية الرقمية', en: 'Digital IP Rights Violation' },
      { ar: 'التحرش الإلكتروني', en: 'Electronic Harassment' },
      { ar: 'نشر المحتوى المخالف', en: 'Publishing Illegal Content' },
      { ar: 'قضايا التطبيقات والألعاب', en: 'App and Game Cases' },
      { ar: 'الجرائم المالية الإلكترونية', en: 'Electronic Financial Crimes' }
    ],

    faqs: [
      {
        questionAr: 'ماذا أفعل إذا تعرضت للابتزاز الإلكتروني؟',
        questionEn: 'What should I do if I face electronic blackmail?',
        answerAr: 'أولاً: لا تستجب للمبتز، ثانياً: احتفظ بجميع الأدلة (محادثات، صور، فيديوهات)، ثالثاً: تواصل معنا فوراً لرفع بلاغ رسمي وحماية حقوقك القانونية.',
        answerEn: 'First: Do not respond to the blackmailer, Second: Keep all evidence (conversations, photos, videos), Third: Contact us immediately to file an official report and protect your legal rights.'
      },
      {
        questionAr: 'هل يمكن تتبع المجرم الإلكتروني؟',
        questionEn: 'Can the cybercriminal be tracked?',
        answerAr: 'نعم، بالتعاون مع الجهات المختصة مثل هيئة الأمن السيبراني ووزارة الداخلية، يمكن تتبع المجرمين الإلكترونيين من خلال الأدلة الرقمية وعناوين IP.',
        answerEn: 'Yes, in cooperation with competent authorities such as the National Cybersecurity Authority and Ministry of Interior, cybercriminals can be tracked through digital evidence and IP addresses.'
      },
      {
        questionAr: 'كم تستغرق قضايا الجرائم المعلوماتية؟',
        questionEn: 'How long do cybercrime cases take?',
        answerAr: 'تختلف المدة حسب تعقيد القضية، لكن عادةً تستغرق من 3 إلى 6 أشهر. القضايا العاجلة مثل الابتزاز يتم التعامل معها بسرعة أكبر.',
        answerEn: 'Duration varies depending on case complexity, but usually takes 3 to 6 months. Urgent cases like blackmail are handled more quickly.'
      },
      {
        questionAr: 'ما عقوبة الجرائم الإلكترونية في السعودية؟',
        questionEn: 'What is the penalty for cybercrimes in Saudi Arabia?',
        answerAr: 'حسب نظام مكافحة الجرائم المعلوماتية، تتراوح العقوبات من السجن حتى 10 سنوات وغرامة مالية تصل إلى 5 ملايين ريال، حسب نوع الجريمة وخطورتها.',
        answerEn: 'According to the Anti-Cybercrime Law, penalties range from imprisonment up to 10 years and fines up to 5 million riyals, depending on the type and severity of the crime.'
      }
    ]
  };

  return <ServiceTemplate serviceData={serviceData} />;
};

export default CybercrimePage;